import React, { useEffect, useRef, useState } from "react";
import { Button as UploadButton, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import AuthService from "../../Components/auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { Table, Button as AntButton, Input, Descriptions, Tag, Row, Col, Divider, Flex, Tooltip, Modal, Image, DatePicker, Typography, Alert, Space, Checkbox, Card, Grid } from "antd";
import { ArrowLeftOutlined, CalendarOutlined, CheckCircleTwoTone, CloseOutlined, DeleteFilled, ExportOutlined, FileDoneOutlined, InfoCircleTwoTone, NumberOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { extractOriginalFileName, formatBatchCode, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "../../Components/common/CommonFun";
import { env, wms_uploads_cdn } from "../../Components/config";
import { useSelector } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import ScanInput from "../Scan/ScanInput";
import './dashboard.css'
import ProductInfoModal from "../../Components/Modals/ProductInfoModal";
import ProductScanSelect from "../Scan/ProductScanSelect";
import InfoCards from "../../Components/InfoCards";
import CustomTag from "../../Components/CustomTag";
import DetailsGrid from "../../Components/common/DetailsGrid";
import { palletTypes, productCategories, productCategoriesByID } from "../../Components/common/Constants";
const { useBreakpoint } = Grid;

const ReceivedStock = () => {
  const { products } = useSelector((state) => state.AppState?.userCreds);
  const { TextArea } = Input;
  const { Text } = Typography;
  const screens = useBreakpoint(); 
  
  let layoutDispatch = useLoadingDispatch();
  const Auth = new AuthService();
  const navigate = useNavigate();
  const [documentNumber, setDocumentNumber] = useState("");
  const [receivedItems, setReceivedItems] = useState([]);
  const [notes, setNotes] = useState("");
  const [detailsPO, setDetailsPO] = useState(null);

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [receiveStatus, setReceiveStatus] = React.useState(false);

  const [timeArrived, setTimeArrived] = React.useState(null)
  const [temperature, setTemperature] = React.useState('')
  const [bookingfiles, setBookingFiles] = useState([]);
  const [bookingCurrentItemFiles, setBookingCurrentItemFiles] = useState([]);
  console.log(timeArrived);
  

  const [batchTransactions, setBatchTransactions] = useState([]);
  const [itemDetails, setItemDetails] = useState({
    product: "",
    product_id: '',
    quantity: "",
    productText: '',
    productStatus: null,
    expiry_date: null,
    batch_code: "",
    supplier_batch_code: "",
    remaining_quantity_check: false
  });

  const [bookingDetails, setBookingDetails] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const productRef = useRef(null);
  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        productRef.current?.focus();
      }, 100);
    }
  }, [modalVisible]);

  const handleSelect = async (record) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/stock-batches?purchase_order_detail_id=${record?.purchase_order_detail_id}`);
      if (res?.ack) {
        const totalQuantityAdded = res?.stock_batches.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
        const currentItemBatchId = res?.stock_batches[0]?.purchase_order_detail_id;
        const updatedRemainingQty = record?.quantity - totalQuantityAdded;
        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
        const updatedReceivedData = receivedItems.map(item => {
          if (item.purchase_order_detail_id === currentItemBatchId) {
            return { ...item, remaining_quantity: updatedRemainingQty, batch_quantity: totalQuantityAdded };
          }
          return item;
        });
        setSelectedItem(updatedRecord);
        setReceivedItems(updatedReceivedData)

        setModalVisible(true);
        setBatchTransactions(res?.stock_batches || []);
      } else {
        showMessage('error', res?.message);
        setBatchTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching stock batches:", error);
      showMessage('error', "Something went wrong while fetching stock batches");
      return;
    } finally {
      hideLoading(layoutDispatch);
    }

  };

  const getBookingDetails = async (doc) => {
  const po_number = doc ? doc : documentNumber;
  const url =
    env === "prod"
      ? `https://magnabooking.com/api/tms/bookings?po_number=${po_number}`
      : env === "uat"
      ? `https://bookings.prefectos-dev.com/api/tms/bookings?po_number=${po_number}`
      : `http://localhost:3000/api/tms/bookings?po_number=${po_number}`;

  try {
    const res = await fetch(url);
    if (res?.status === 200) {
      const data = await res.json();
      const bookings = data?.bookings ?? [];
      if (bookings.length > 0 ) {
        const myBooking = [bookings[bookings.length - 1]]
        if(myBooking?.length > 0 && myBooking[0]?.received_at) {
           console.log(myBooking, 'myBooking');
        const time = myBooking[0]?.time_arrived
        const date = myBooking[0]?.received_at
        const dateTime = `${date} ${time}`;
        const value = dayjs(dateTime, "YYYY-MM-DD HH:mm");
        setTimeArrived(value)        
        // setBookingCurrentItemFiles(myBooking[0]?.files ? JSON.parse(myBooking[0]?.files) : [])
        setBookingCurrentItemFiles(
  Array.isArray(myBooking[0]?.files)
    ? myBooking[0].files
    : myBooking[0]?.files
    ? JSON.parse(myBooking[0].files)
    : []
);


        setBookingDetails(myBooking); // only last item
        } else {
        setBookingDetails([]); // keep empty

        }
       
      } else {
        setBookingDetails([]); // keep empty
      }
    }
  } catch (err) {
    console.log(err);
  }
};

console.log('time', timeArrived);


const saveBookingDetails = async () => {
  const url =
    env === "prod"
      ? `https://magnabooking.com/api/tms/savebooking`
      : env === "uat"
      ? `https://bookings.prefectos-dev.com/api/tms/savebooking`
      : `http://localhost:3000/api/tms/savebooking`;

  const payload = {
    id: bookingDetails[0]?.id,
    temperature_inbound: temperature,
    time_arrived: timeArrived ? dayjs(timeArrived).format("HH:mm") : null,
    files: bookingCurrentItemFiles ? bookingCurrentItemFiles : []
  }

  console.log(payload);

  try {
    const res = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
    if (res?.status === 200) {
      const data = await res.json();
      const uploadPromises = []
        if (bookingfiles.length > 0) {
          bookingfiles.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, 'receive-stock/supplier-bookings', documentNumber)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
      console.log(data, 'save booking');
      
    }
  } catch (err) {
    console.log(err);
  }
};


  const handleSearch = async (doc) => {

    setNotes("");
    setFiles([]);
    setBookingFiles([])
    setCurrentItemFiles([]);
    setBookingCurrentItemFiles([])
    setDeletedFiles([]);
    setDetailsPO(null);
    setReceiveStatus(null)
    setReceivedItems([])
    setModalVisible(false)
    if (doc.trim() === "") {
      showMessage('error', "Please enter the Document Number.");
      return;
    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ns/get-purchase-order?id=${doc}`);
      if (res.ack) {

        const items = res?.order ?? [];
        const updatedItems = items.map(item => ({
          ...item,
          initialRemainingQuantity: item.quantity - item.batch_quantity,
          batch_code: item.batch_code || '',
          expiry_date: null,
          remaining_quantity: item?.quantity - Number(item.batch_quantity)
        }));
        console.log('updatedItems', updatedItems);
        setDetailsPO(res?.order[0]);
        setReceivedItems(updatedItems);
        setReceiveStatus(res?.order[0]?.received_by > 0 ? true : false)
        setNotes(res?.order[0]?.notes)
        setCurrentItemFiles(res?.order[0]?.files ? JSON.parse(res?.order[0]?.files) : [])
        getBookingDetails(doc)
      } else {
        if (res?.already_received === true) {
          Modal.confirm({
            title: "Already Received",
            content: "This Purchase Order is already received. do you want to receive it directly?",
            okText: "Yes",
            onOk: () => receiveInSystem(res?.receiptId),
            cancelText: 'Cancel',
            width: 600,
            okButtonProps: { size: "large" },
            cancelButtonProps: { size: "large" },
          });
        }
        setReceivedItems([]);
        showMessage('error', res?.message);
        setDetailsPO(res)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/stock-batches`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        setModalVisible(false);
        handleSearch(documentNumber);
      } else {
        showMessage('error', res?.message);
        // handleSearch();
        hideLoading(layoutDispatch);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    }
  };

  const batchCol = [
    {
      title: "Batch Code",
      dataIndex: 'batch_code',
      key: 'batch_code',
    },
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

    {
      title: "Supplier Batch Code",
      dataIndex: 'supplier_batch_code',
      key: 'supplier_batch_code',
    },
    {
      title: "Qty",
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(quantity)?.toLocaleString() || 0} </Tag>;
      },
      align: 'center',
    },

  ]
  if (!receiveStatus && !receivedItems[0]?.already_received_on_netsuite > 0) {
    batchCol.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }}
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure to delete this transaction?`,
                  onOk: () => deleteTransaction(record.id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    })
  }

  const [selectedProductDetails, setSelectedProductDetails] = useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: []
  })
  const [modalVisibleProduct, setModalVisibleProduct] = useState(false);

  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, product: null, productDetails: [] });
    setModalVisibleProduct(false);
  }
  const handleInfoClick = async (record) => {
    const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };



  const dataCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: '60px',
    },
    {
      title: "Item",
      sorter: (a, b) =>
        `${a?.product_code || ""} ${a?.product_name || ""}`.localeCompare(
          `${b?.product_code || ""} ${b?.product_name || ""}`
        ),
      render(record) {

        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>

              <InfoCircleTwoTone style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => handleInfoClick(record)} />
            </Tooltip>
            <span>{`${record?.product_code} - ${record?.product_name}`}</span>

          </Flex>
        )

      }
    },
    // {
    //   title: "Category",
    //   render: (record) => {
    //     const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
    //     return (
    //       <span>{item?.category ? item?.category : '-'}</span>
    //     )
    //   }
    // },
    {
      title: "Category",
      sorter: (a, b) => {
        const catA =
          products?.find((item) => item.netsuite_id == a?.product_netsuite_id)
            ?.sub_category || "";
        const catB =
          products?.find((item) => item.netsuite_id == b?.product_netsuite_id)
            ?.sub_category || "";
        return catA.localeCompare(catB);
      },
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <span>{item?.sub_category ? item?.sub_category : '-'}</span>
        )
      }
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: (a, b) => (a.quantity || 0) - (b.quantity || 0),
      render: (quantity) => {
        return <span>{quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Received Qty',
      sorter: (a, b) => (a.batch_quantity || 0) - (b.batch_quantity || 0),
      render: (record) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.batch_quantity)?.toLocaleString() || 0} </Tag> ;
      },
    },
    {
      title: 'Remaining Qty',
      sorter: (a, b) =>
        (a.remaining_quantity || 0) - (b.remaining_quantity || 0),
      render: (record) => {
        return <Tag color={record?.remaining_quantity > 0 ? 'red' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.remaining_quantity?.toLocaleString()}</Tag>;
      }
    },

    {
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Select Item">
          <ExportOutlined
            className="animated-select-icon"
            onClick={() => handleSelect(record)}
          />
        </Tooltip>
      ),
    }

  ]

  const submitImage = (e) => {
     e.persist?.();
    handleSubmitImage(e, setFiles, setCurrentItemFiles)
    handleSubmitImage(e, setBookingFiles, setBookingCurrentItemFiles)
  }

  console.log('files', files, bookingfiles, bookingCurrentItemFiles);
  

  const productValueChange = (value) => {
    setItemDetails({ ...itemDetails, product: value });
  };

  const productBlur = () => {
    if (!itemDetails?.product) {
      setItemDetails({ ...itemDetails, productStatus: 'error', productText: 'No Product Entered', batch_code: '' })
      return;
    } else {
      const selectedProduct = products?.find((pro) => pro?.code == itemDetails?.product || pro?.barcode == itemDetails?.product);
      const matchedProduct = selectedItem?.product_netsuite_id == selectedProduct?.netsuite_id ? true : false;
      if (selectedProduct && matchedProduct) {
        const dateFromNowToNextYear = dayjs().add(1, 'year')
        const DateFormat = dayjs(dateFromNowToNextYear).format('DD-MM-YYYY');
        const batchCode = formatBatchCode(documentNumber, DateFormat, selectedItem?.product_code);
        const firstCharacter = selectedProduct?.code?.charAt(0);
        if (firstCharacter != 'C') {
          setItemDetails({ ...itemDetails, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name, batch_code: batchCode, expiry_date: dayjs(dateFromNowToNextYear, 'YYYY-MM-DD') });

        } else {

          setItemDetails({ ...itemDetails, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name, batch_code: null, expiry_date: null });
        }

      } else {
        setItemDetails({ ...itemDetails, productStatus: 'error', productText: 'Invalid Product', batch_code: '', product: '', product_id: '' })
      }
    }
  };

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);

    const selectedProduct = isScanned
      ? products?.find((pro) => pro?.code === val || pro?.barcode === val)
      : products?.find((pro) => pro?.netsuite_id === val);

    const matchedProduct = selectedItem?.product_netsuite_id === selectedProduct?.netsuite_id;

    if (selectedProduct && matchedProduct) {
      const dateFromNowToNextYear = dayjs().add(1, 'year')
      const DateFormat = dayjs(dateFromNowToNextYear).format('DD-MM-YYYY');
      const batchCode = formatBatchCode(documentNumber, DateFormat, selectedItem?.product_code);
      const firstCharacter = selectedProduct?.code?.charAt(0);
      if (firstCharacter != 'C') {
        setItemDetails({ ...itemDetails, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name, batch_code: batchCode, expiry_date: dayjs(dateFromNowToNextYear, 'YYYY-MM-DD') });

      } else {

        setItemDetails({ ...itemDetails, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name, batch_code: null, expiry_date: null });
      }

    } else {
      setItemDetails({ ...itemDetails, productStatus: 'error', productText: 'Invalid Product', batch_code: '', product: '', product_id: '' })
      showMessage('error', 'Invalid Product Selected');
    }
  };


  const handleModalCancel = () => {
    setSelectedItem(null);
    setItemDetails({ product: "", product_id: '', quantity: "", productText: '', productStatus: null, expiry_date: null, remaining_quantity_check: false })
    setModalVisible(false);
  };

  const handleModalOk = async () => {
    console.log('itemDetails', itemDetails);
    if (!itemDetails?.product_id || !itemDetails?.quantity || !itemDetails?.expiry_date || !itemDetails?.supplier_batch_code) {
      showMessage('error', "Please fill all the required fields.");
      return;
    }
    if (Number(itemDetails?.quantity) <= 0) return showMessage('error', "Quantity must be greater than zero.");
    const dataToSend = {
      purchase_order_detail_id: selectedItem?.purchase_order_detail_id,
      quantity: itemDetails?.quantity,
      expiry_date: itemDetails?.expiry_date ? dayjs(itemDetails?.expiry_date).format("YYYY-MM-DD") : '',
      batch_code: itemDetails?.batch_code,
      supplier_batch_code: itemDetails?.supplier_batch_code,

    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/stock/stock-batches", {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        setModalVisible(false);
        setReceivedItems(prevItems =>
          prevItems.map(item => {
            if (item.product_code === selectedItem.product_code) {
              const currentQty = Number(item.batch_quantity) || 0;
              const newQty = currentQty + Number(itemDetails.quantity);
              const newRem = selectedItem?.remaining_quantity - Number(itemDetails?.quantity)
              return { ...item, batch_quantity: newQty, remaining_quantity: newRem };
            }
            return item;
          })
        );
        setItemDetails({ product: "", product_id: '', quantity: "", productText: '', productStatus: null, expiry_date: null, batch_code: '', supplier_batch_code: '', remaining_quantity_check: false });
        setSelectedItem(null);
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (error) {
      console.error("Error saving item details:", error);
      showMessage('error', "Something went wrong while saving item details");
      // hideLoading(layoutDispatch);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  console.log('item details', itemDetails);


  const resetPurchaseOrder = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-po`, {
        method: "DELETE",
        body: JSON.stringify({ po_number: documentNumber })

      });
      if (res?.ack) {
        handleSearch(documentNumber);
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch)

    }
  };

  const receiveInSystem = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ns/receive-purchase-order-netsuite`, {
        method: "POST",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        handleSearch(documentNumber);
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch)

    }
  };

  const fetchUpdatedDetails = async () => {
    setNotes('')
    setFiles([])
    setBookingFiles([])
    setCurrentItemFiles([])
    showLoading(layoutDispatch);

    try {
      const res = await Auth.fetch(`/stock/purchase-order-details?id=${receivedItems[0]?.id}`);
      if (res?.ack) {
        showMessage('success', res?.message);
        setNotes(res?.purchase_order[0]?.notes)
        setCurrentItemFiles(res?.purchase_order[0]?.files ? JSON.parse(res?.purchase_order[0]?.files) : [])
        setReceiveStatus(res?.purchase_order[0].received_by > 0 ? true : false);
        setDetailsPO(res?.purchase_order[0])
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const postData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      id: detailsPO?.id,
      notes: notes,
      files: currentItemFiles ? currentItemFiles : [],
    }
    try {
      const res = await Auth.fetch(`/stock/receive-po-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        fetchUpdatedDetails()
        saveBookingDetails()
        showMessage('success', res?.message);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, 'receive-stock', documentNumber)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        // setDetailsPO(null)
        setNotes('')
        setFiles([])
        setBookingFiles([])
        setReceiveStatus(false)
        // setReceivedItems([])
        setCurrentItemFiles([])
        // navigate("/stocks");
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };
  const saveData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      id: detailsPO?.id,
      notes: notes,
      files: currentItemFiles ? currentItemFiles : [],
    }
    try {
      const res = await Auth.fetch(`/stock/save-po-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        fetchUpdatedDetails()

        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, 'receive-stock', documentNumber)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        // navigate("/stocks");
        // fetchUpdatedDetails()
        if(!receiveStatus) saveBookingDetails()

      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };

  const handleValueChange = (value, isScanned) => {
    console.log('latest values', value, isScanned, documentNumber);

    setDocumentNumber(value);

    if (isScanned) {
      handleSearch(value);

    }
  };


  const infoItems = [
    {
      label: 'Supplier',
      value: `${detailsPO?.supplier_code || ''} - ${detailsPO?.supplier_name || ''}`,
      type: 'text',
      icon: <UserOutlined style={{ color: "#52c41a" }} />,
    },
    {
      label: 'Order Date',
      value: detailsPO?.posting_date ? dayjs(detailsPO?.posting_date).format('DD-MM-YYYY') : 'N/A',
      type: 'text',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
    },
    {
      label: 'Receive By Date',
      value: detailsPO?.received_date ? dayjs(detailsPO?.received_date).format('DD-MM-YYYY') : 'N/A',
      type: 'text',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
    },
  ]

   if (receiveStatus) {
    infoItems.push({
      label: 'Receipt Code',
      value: detailsPO?.receipt_code || 'N/A',
      type: 'text',
      icon: <FileDoneOutlined style={{ color: "#1677ff" }} />,
    })
  }

  

 


  const infoItemModal = [
    { label: 'Total Quantity', value: selectedItem?.quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: '#1677ff' },
    { label: 'Remaining Quantity', value: selectedItem?.remaining_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: selectedItem?.remaining_quantity > 0 ?  'red' : '#1677ff' },
  ]

  const detailFields = [
  { key: "reference", label: "Reference No." },
  { key: "booking_date", label: "Booking Date" },
  // { key: "time_slot_start", label: "Time Slot Start" },
  { key: "time_slot", label: "Time Slot" },
  { key: "temperature_category", label: "Temperature Category" },
  { key: "no_of_pallet", label: "Number of Pallets" },
  { key: "pallet_type", label: "Pallet Type" },
];

console.log(bookingDetails);


  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Receive Stock</h3>
        <AntButton icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</AntButton>
      </div>
      <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
        <Flex gap="small">
          <ScanInput onValueChange={handleValueChange} value={documentNumber} placeholder={'Search Document'} size={'default'} length={'100%'} autoFocus={true} />
          <AntButton type="primary" onClick={() => handleSearch(documentNumber)}>Search</AntButton>
        </Flex>
        <Flex justify="end" align="center">
          {receiveStatus === true && (
            <CustomTag color="blue">
              Received
            </CustomTag>
          )}

          {detailsPO?.posted_by > 0 && (
            <CustomTag
              style={{ margin: 0 }}
              color="red"
            >
              Posted
            </CustomTag>
          )}
        </Flex>
      </Flex>
      <>
        <>
          {
            detailsPO?.mismatch && (
              <Alert
                style={{ marginTop: "10px" }}
                banner
                message="Irregularities were detected in this purchase order. Please reset it to continue."
                type="warning" showIcon closable
                action={
                  <Space>
                    <AntButton type="primary" size="small"
                      onClick={() => {
                        Modal.confirm({
                          title: 'Reset Order',
                          centered: true,
                          content: `Are you sure to reset this order? This action cannot be undone.`,
                          onOk: () => resetPurchaseOrder(),
                          okText: 'Reset',
                          cancelText: 'Cancel',
                          width: 600,
                          okButtonProps: { size: "large" },
                          cancelButtonProps: { size: "large" },
                        });
                      }}
                    >
                      Reset Order
                    </AntButton>
                  </Space>
                }
              />
            )
          }
          {/* {
            detailsPO?.already_received && (
              <Alert
                style={{ marginTop: "10px" }}
                banner
                message="Purchase order already received in Netsuite, do you want to receive it directly?"
                type="warning" showIcon closable
                action={
                  <Space>
                    <AntButton type="primary" size="small"
                      onClick={() => {
                        Modal.confirm({
                          title: 'Reset Order',
                          centered: true,
                          content: `Are you sure to reset this order? This action cannot be undone.`,
                          onOk: () => receiveInSystem(),
                          okText: 'Reset',
                          cancelText: 'Cancel',
                          width: 600,
                          okButtonProps: { size: "large" },
                          cancelButtonProps: { size: "large" },
                        });
                      }}
                    >
                      Receive in System
                    </AntButton>
                  </Space>
                }
              />
            )
          } */}


          {
            detailsPO != null && (
              <>
                {/* <InfoCards items={infoItems} /> */}
                <DetailsGrid infoItems={infoItems} />
              </>
            )
          }
        </>
        <div>

          <Table
            dataSource={receivedItems}
            columns={dataCol}
            pagination={false}
            scroll={{ x: 'max-content' }}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />

        </div>
          { receivedItems?.length > 0 && (
            
            <>
            <Divider style={{ height: "2px", background: "#006cb8" }} />
            <h3 style={{ margin: 0 }}>Booking Details</h3>
             
  {bookingDetails?.length > 0 ? (
    <>
      {bookingDetails.map((booking, index) => (
        <React.Fragment key={index}>
        <Row gutter={[6,6]}>
          {detailFields.map((field) => {
            let rawValue = booking?.[field.key];
             if (field.key === "temperature_category" && rawValue) {
              const found = productCategoriesByID.find((t) => t.id === rawValue);
              rawValue = found ? found.title : "N/A";
              }

              if (field.key === "pallet_type" && rawValue) {
              const found = palletTypes.find((t) => t.id == rawValue);
              rawValue = found ? found.title : "N/A";
              booking._palletTypeColor = found ? found.color : null;
              }
              if (field.key === "booking_date" && rawValue) {
                const date = booking?.booking_date ? dayjs(booking?.booking_date).format('DD-MM-YYYY') : 'N/A'
              rawValue = date;
              }
              if (field.key === "time_slot") {
              const start = booking?.time_slot_start || "N/A";
              const end = booking?.time_slot_end || "N/A";
              rawValue = `${start} - ${end}`;
            }
            const value =
              rawValue === null || rawValue === undefined || rawValue === ""
                ? "N/A"
                : rawValue;

            return (
              <>
              <Col xs={24} sm={24} md={12} lg={8} key={`${index}-${field.key}`}>
                <Card
                  size="small"
                  style={{
                    borderRadius: 12,
                    background: "#f1f1f1",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    marginBottom: 4,
                  }}
                >
                  <Flex
                    justify="space-between"
                    vertical={!screens.lg}
                    align={screens.lg ? "center" : "start"}
                    gap={6}
                    wrap
                  >
                    <Flex align="center" gap={8}>
                      {field.icon}
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#595959",
                        }}
                      >
                        {field.label}
                      </span>
                    </Flex>
                    <Flex
                    align="center"
                    gap={8}
                    style={{
                      maxWidth: screens.lg ? "60%" : "100%",
                      textAlign: screens.lg ? "right" : "left",
                      fontSize: "14px",
                    }}
                  >
                    {field.key === "pallet_type" && booking._palletTypeColor && (
                      <span
                        style={{
                          display: "inline-block",
                          width: 14,
                          height: 14,
                          borderRadius: 4,
                          background: booking._palletTypeColor,
                        }}
                      />
                    )}
                    <Text strong ellipsis>
                      {value}
                    </Text>
                  </Flex>

                  </Flex>
                </Card>
              </Col>
              
              </>
            );
          })}
        </Row>
        <Row style={{ marginTop: 10}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8}>
          <Text>Time Arrived</Text>
          <DatePicker
            format={'DD-MM-YYYY HH:mm'}
            style={{ width: '100%'}}
            size="large"
            showTime={{ minuteStep: 5 }}
            disabled={receiveStatus}
            value={timeArrived ? dayjs(timeArrived) : null}
           
            disabledDate={(current) => {
              const fixedDate = bookingDetails[0]?.received_at;
              return current && current.format("YYYY-MM-DD") !== fixedDate;
            }}
            onChange={(date) => {
              if (!date) {
                setTimeArrived(null);
                return;
              }

              // always keep booking date, only update time
              const fixedDate = bookingDetails[0]?.received_at; // e.g. "2025-09-16"
              const lockedDate = dayjs(fixedDate, "YYYY-MM-DD")
                .hour(date.hour())
                .minute(date.minute());

              setTimeArrived(lockedDate);
            }}
            placeholder="Time Arrived" 
          />
          </Col>
          {/* <Col xs={24} sm={12} md={12} lg={8}>
          <Text>Inbound Temperature</Text>
          <Input
            style={{ width: '100%'}}
            size="large"
            value={temperature}
            onChange={(e) => { setTemperature(e.target.value)
            }}
            placeholder="Temperature" 
          />
          </Col> */}
          {booking?.temperature_category !== 1 && (
            <Col xs={24} sm={12} md={12} lg={8}>
              <Text>Inbound Temperature</Text>
              <Input
                style={{ width: "100%" }}
                size="large"
                value={temperature}
                onChange={(e) => {
                  setTemperature(e.target.value);
                }}
                placeholder="Temperature"
              />
            </Col>
          )}
        </Row>
        <Divider />
        </React.Fragment>
        
      ))}
    </>
  ) : (
    <Row gutter={[6, 6]}>
      <Col span={24}>
      <Alert message="No Booking Details Found" type="info" />
    </Col>
    </Row>
    
  )}
            {/* </Row> */}

            




            
        <Divider style={{ height: "2px", background: "#006cb8" }} />
            </>

          )}  
        
        {
          receivedItems?.length > 0 && (

            <>
              <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <span>
                    Notes:
                  </span>
                  <TextArea
                    value={notes}
                    onChange={(e) => { setNotes(e.target.value) }}
                    placeholder='Please enter any notes.'
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    style={{
                      borderColor: receiveStatus === true ? '#1890ff' : undefined,
                      backgroundColor: receiveStatus === true ? '#e6f7ff' : undefined,
                      borderWidth: receiveStatus === true ? '2px' : undefined,
                    }}
                  />

                </Col>
              </Row>
              <div>
                <UploadButton
                  component="label"
                  variant="contained"
                  sx={{ marginTop: "10px" }}
                  startIcon={<CloudUploadIcon />}
                >
                  Add files
                  <input
                    type="file"
                    hidden
                    multiple
                    capture
                    accept="image/*, video/*"
                    onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                    onChange={(e) => {
                      const myfiles = e.target.files;

                      if (myfiles.length > 10) {
                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                        e.target.value = "";
                      } else {
                        submitImage(e);
                      }
                    }}
                  />
                </UploadButton>
              </div>

              {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
              <Image.PreviewGroup>
                          {currentItemFiles?.length > 0 &&
                            currentItemFiles
                              .filter((item) => !files.some((file) => file.name === item))
                              .map((item) => {
                                const encodedFileName = item.replace(/\+/g, '%2B');
                                const imageUrl = `${wms_uploads_cdn}/${env}/receive-stock/${documentNumber}/${encodedFileName}`;
                                return (
                                  <div
                                    style={{
                                      position: "relative",
                                      marginRight: "10px",
                                      display: "inline-block",
                                    }}
                                  >
                                    <Image
                                      width={200}
                                      height={150}
                                      style={{ padding: "5px", border: "1px solid lightgrey" }}
                                      src={imageUrl}
                                    />
                                    <Tooltip title="Delete">
                                      <CloseOutlined
                                        style={{
                                          fontSize: "30px",
                                          position: "absolute",
                                          right: 5,
                                          top: 5,
                                          color: "#c12828",
                                        }}
                                        onClick={() => {
                                          handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles)
                                          handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, bookingCurrentItemFiles, setBookingCurrentItemFiles)
                                        }
                                        }
                                      />
                                    </Tooltip>
                                  </div>
                                );
                              })}
                        </Image.PreviewGroup>
              {/* <ul>
                {currentItemFiles?.length > 0 &&
                  currentItemFiles
                    .filter(
                      (item) =>
                        !files.some((file) => file.name === item)
                    )
                    .map((item) => {
                      const encodedFileName = item.replace(/\+/g, '%2B');
                      return (
                        <li>
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles,)}
                          >
                            <DeleteIcon />
                          </IconButton>

                          <a
                            href={`${wms_uploads_cdn}/${env}/receive-stock/${documentNumber}/${encodedFileName}`}
                            target="_blank"
                          >
                            {extractOriginalFileName(encodedFileName)}
                          </a>
                        </li>
                      );
                    })}
              </ul> */}

              {files?.length > 0 && <Divider />}

              {files?.length > 0 && <h4>Files:</h4>}
              <Image.PreviewGroup>
                          {files?.length > 0 &&
                            files.map((item) => {
                              return (
                                <div
                                  style={{
                                    position: "relative",
                                    marginRight: "10px",
                                    display: "inline-block",
                                  }}
                                >
                                  <Image
                                    width={200}
                                    height={150}
                                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                                    src={URL.createObjectURL(item?.file)}
                                  />
                                  <Tooltip title="Delete">
                                    <CloseOutlined
                                      style={{
                                        fontSize: "30px",
                                        position: "absolute",
                                        right: 5,
                                        top: 5,
                                        color: "#c12828",
                                      }}
                                      onClick={() => {
                                        handleDeleteFile(item?.name, files, currentItemFiles, setFiles, setCurrentItemFiles)
                                        handleDeleteFile(item?.name, bookingfiles, bookingCurrentItemFiles, setBookingFiles, setBookingCurrentItemFiles)
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                              );
                            })}
                        </Image.PreviewGroup>
              {/* <ul>
                {files.length > 0 &&
                  files.map((file) => {
                    const encodedFileName = file?.name.replace(/\+/g, '%2B');
                    return (
                      <li>
                        {" "}
                        <IconButton
                          aria-label="delete"
                          color="primary"
                          onClick={() => handleDeleteFile(file.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        {extractOriginalFileName(encodedFileName)}
                      </li>
                    );
                  })}
              </ul> */}
              {files?.length > 0 && <Divider />}
            </>
          )
        }
        <Flex justify="end" gap={5}>


          {
            receivedItems?.length > 0 && (
              <>
                {
                  !receiveStatus && <AntButton size="large" type="primary"
                    //  onClick={()=> postData()}
                    onClick={() => {
                      Modal.confirm({
                        title: 'Post Order',
                        centered: true,
                        content: `Are you sure to post this order? This action cannot be undone.`,
                        onOk: () => postData(),
                        okText: 'Post',
                        cancelText: 'Cancel',
                        width: 600,
                        okButtonProps: { size: "large" },
                        cancelButtonProps: { size: "large" },
                      });
                    }}
                  >Post</AntButton>
                }
                <AntButton size='large' onClick={() => saveData()}>Save</AntButton>
              </>
            )
          }

        </Flex>
        <Modal width={'70vw'} title={`Received Batches: ${selectedItem?.product_code} - ${selectedItem?.product_name}`} open={modalVisible}
          // onOk={handleModalOk} 
          onCancel={handleModalCancel}
          //  okText="Save"
          okButtonProps={{ disabled: !itemDetails?.product_id, style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
          bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 6 }}
          style={{ top: 40 }}
        >
          <Divider style={{ margin: '5px 0px' }} />

          <>
          <DetailsGrid infoItems={infoItemModal} />
            
            <>
              {
                selectedItem?.remaining_quantity > 0 && !receiveStatus && !selectedItem?.already_received_on_netsuite > 0 && (
                  <>
                    <Row style={{ marginBottom: "10px" }}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Text>Product<span style={{ color: 'red' }}>*</span></Text>
                        {/* <Flex align="center" gap="small">
                          <ScanInput onValueChange={productValueChange} value={itemDetails?.product} placeholder="Product" size={'large'} onBlur={productBlur} />
                          <Text type={itemDetails.productStatus == "error" ? "danger" : itemDetails.productStatus == "success" ? "success" : ""}>
                            {itemDetails.productText}
                          </Text>
                        </Flex> */}
                        <ProductScanSelect
                          onValueChange={productSelectValueChange}
                          value={itemDetails?.product_id}
                          options={products} placeholder="Product"
                          size="large"
                          length={'100%'}
                          productRef={productRef}
                        />
                      </Col>
                    </Row>
                    <Row >
                      <Col>
                        <Text>Quantity<span style={{ color: 'red' }}>*</span></Text>
                        <Flex align="center" gap="small">
                          <Input size="large" type='number' value={itemDetails?.quantity}
                            onChange={(e) => {
                              if (!itemDetails?.product_id) {
                                setItemDetails({ ...itemDetails, productStatus: 'error', productText: 'Please select a product first' })
                                showMessage('error', 'Please select a product first');
                                return;
                              }
                              // const newQty = e.target.value
                              const raw = e.target.value;
                             const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                              // if (newQty < 0) {
                              //   showMessage('error', 'Quantity cannot be negative');
                              //   return;
                              // }
                              if (newQty > selectedItem?.remaining_quantity) {
                                showMessage('error', `Quantity cannot be greater than ${selectedItem?.remaining_quantity}`);
                                return;
                              } else {
                                setItemDetails({ ...itemDetails, quantity: newQty })
                              }
                            }
                            }
                            style={{ width: "290px" }} placeholder="Quantity" />

                          <Checkbox
                            checked={itemDetails?.remaining_quantity_check}
                            style={{ fontSize: '16px' }}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              const qtyRemaing = selectedItem?.remaining_quantity;
                              if (isChecked) {
                                if (!itemDetails?.product_id) {
                                  showMessage('error', 'Please select a product first');
                                  return;
                                }

                                setItemDetails({ ...itemDetails, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                              }
                              else {
                                setItemDetails({ ...itemDetails, quantity: '', remaining_quantity_check: false });
                              }
                            }}
                          >
                            Remaining Quantity
                          </Checkbox>
                        </Flex>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <Text>Expiry Date<span style={{ color: 'red' }}>*</span></Text>
                        <br />
                        <DatePicker
                          format={'DD-MM-YYYY'}
                          style={{ width: '290px' }}
                          size="large"
                          value={itemDetails?.expiry_date}
                          onChange={(date) => {
                            if (!itemDetails?.product_id) {
                              showMessage('error', 'Select a product first')
                              return;
                            }
                            if (!date) {
                              // If user clears the date
                              setItemDetails({ ...itemDetails, expiry_date: null, batch_code: '' });
                              return;
                            }
                            const DateFormat = dayjs(date).format('DD-MM-YYYY');
                            const batchCode = formatBatchCode(documentNumber, DateFormat, selectedItem?.product_code);
                            setItemDetails({ ...itemDetails, expiry_date: date ? dayjs(date, 'YYYY-MM-DD') : null, batch_code: batchCode })
                          }}
                          placeholder="Expiry Date"
                          disabledDate={(current) => {
                            return current && current < dayjs().startOf('day')
                          }}

                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <Text>Supplier Batch Code<span style={{ color: 'red' }}>*</span></Text>
                        <br />
                        <Input size="large" value={itemDetails?.supplier_batch_code}
                          onChange={(e) => setItemDetails({ ...itemDetails, supplier_batch_code: e.target.value })}
                          style={{ width: "290px" }} placeholder="Supplier Batch Code" />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <Text>Batch Code</Text>
                        <br />
                        <Input size="large" value={itemDetails?.batch_code}
                          disabled
                          style={{ width: "290px" }} placeholder="Batch Code" />
                      </Col>
                    </Row>
                    <Divider />
                    <Flex justify="end" gap={5}>
                      <AntButton onClick={() => handleModalCancel()}>Cancel</AntButton>
                      {
                        itemDetails?.product_id && (
                          <AntButton type="primary"
                            onClick={() => handleModalOk()}
                          >
                            Save
                          </AntButton>
                        )
                      }
                    </Flex>

                  </>
                )
              }
            </>
            {
              batchTransactions?.length > 0 && (
                <Table
                  dataSource={batchTransactions}
                  columns={batchCol}
                  pagination={false}
                  style={{ marginTop: "10px" }}
                  scroll={{ x: 'max-content' }}
                  rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                />
              )
            }
          </>
        </Modal>
        <ProductInfoModal
          visible={modalVisibleProduct}
          onCancel={handleModalCancelProduct}
          selectedItemDetails={selectedProductDetails}
          selectedItems={selectedProductDetails?.productDetails}
        // selectedRecord={selectedRecord}
        />
      </>
    </>
  );
};

export default ReceivedStock;
